export const GLOBAL_POLL_TIMEOUT_MS = 5 * 60 * 1000;

export function getDelayAfterPoll(pollsCompleted: number): number {
  if (pollsCompleted <= 3) return 3000;
  if (pollsCompleted <= 6) return 5000;
  return 8000;
}
export const GARMENT_COMBINATION_POLL_INTERVAL_MS = 15000;
export const GARMENT_COMBINATION_POLL_TIMEOUT_MS = 11 * 60 * 1000;
export const GARMENT_COMBINATION_REQUEST_TIMEOUT_MS = 5 * 60 * 1000;
